import { visit } from '../libs/Visitor'
import { Scheduler } from '../types/scheduler'
import { DataResponse } from '../types/response'

export type CronDescriptorResponse = DataResponse<{ description: string }>

export const scheduler = {
  task: {
    exec(taskId: number) {
      return visit<unknown>({
        method: 'POST',
        url: `scheduler/tasks/${taskId}/exec`
      })
    },
    list(params = {}) {
      return visit<DataResponse<Scheduler.Task[]>>({
        method: 'GET',
        url: 'scheduler/tasks',
        params: params
      })
    },
    get(id: number) {
      return visit<DataResponse<Scheduler.Task>>({
        method: 'GET',
        url: 'scheduler/tasks?id=' + id
      })
    },
    create(item: Scheduler.CreateTaskPayload) {
      return visit<DataResponse<Scheduler.Task>>({
        method: 'POST',
        url: 'scheduler/tasks',
        data: item
      })
    },
    update(item: Scheduler.Task) {
      return visit<DataResponse<Scheduler.Task>>({
        method: 'PUT',
        url: 'scheduler/tasks/' + item.id,
        data: item
      })
    },
    delete(id: number) {
      return visit<DataResponse<Scheduler.Task>>({
        method: 'DELETE',
        url: 'scheduler/tasks/' + id
      })
    }
  },
  spec: {
    list() {
      return visit<DataResponse<Scheduler.Spec[]>>({
        method: 'GET',
        url: 'scheduler/specs'
      })
    },
    get(id: number) {
      return visit<DataResponse<Scheduler.Spec>>({
        method: 'GET',
        url: 'scheduler/specs?id=' + id
      })
    },
    create(item: Scheduler.Spec) {
      return visit<DataResponse<Scheduler.Spec>>({
        method: 'POST',
        url: 'scheduler/specs',
        data: item
      })
    },
    update(item: Scheduler.Spec) {
      return visit<DataResponse<Scheduler.Spec>>({
        method: 'PUT',
        url: 'scheduler/specs/' + item.id,
        data: item
      })
    },
    delete(id: number) {
      return visit<DataResponse<Scheduler.Spec>>({
        method: 'DELETE',
        url: 'scheduler/specs/' + id
      })
    }
  },
  category: {
    list() {
      return visit<DataResponse<Scheduler.Category[]>>({
        method: 'GET',
        url: 'scheduler/categories'
      })
    },
    get(id: number) {
      return visit<DataResponse<Scheduler.Category>>({
        method: 'GET',
        url: 'scheduler/categories?id=' + id
      })
    },
    create(item: Scheduler.Category) {
      return visit<DataResponse<Scheduler.Category>>({
        method: 'POST',
        url: 'scheduler/categories',
        data: item
      })
    },
    update(item: Scheduler.Category) {
      return visit<DataResponse<Scheduler.Category>>({
        method: 'PUT',
        url: 'scheduler/categories/' + item.id,
        data: item
      })
    },
    delete(id: number) {
      return visit<DataResponse<Scheduler.Category>>({
        method: 'DELETE',
        url: 'scheduler/categories/' + id
      })
    }
  }
}
